import { useTranslate } from "ra-core";
import { Card, CardContent } from "@/components/ui/card";
import { formatCurrency } from "../shared/financeFormatters";
import type { AccountBalance } from "../../types";
import { Banknote, CreditCard, Building, Wallet } from "lucide-react";

const icons = {
  cash: Wallet,
  bank: Building,
  card: CreditCard,
  other: Banknote,
} as const;

export const BalanceCard = ({ balance }: { balance: AccountBalance }) => {
  const translate = useTranslate();
  const Icon = icons[balance.type] ?? Banknote;
  const isNegative = balance.current_balance < 0;
  return (
    <Card className="overflow-hidden">
      <CardContent className="px-4 py-3 space-y-1">
        <div className="flex items-center justify-between text-xs text-muted-foreground">
          <span>{balance.name}</span>
          <Icon className="h-4 w-4" />
        </div>
        <div
          className={
            isNegative ? "text-xl font-bold text-rose-600" : "text-xl font-bold"
          }
        >
          {formatCurrency(balance.current_balance, balance.currency)}
        </div>
        <div className="text-xs text-muted-foreground">
          {translate(`resources.accounts.types.${balance.type}`, {
            _: balance.type,
          })}
        </div>
      </CardContent>
    </Card>
  );
};
